import styled from 'styled-components'
import { theme } from '~/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`

interface ILabelProps {
  isPropertyAltered: boolean
}

const NormalPropertyColor = theme.colors.color6b7786
const AlteredPropertyColor = theme.colors.colorcd1f1f
export const Label = styled.div<ILabelProps>`
  flex-grow: 2;
  color: ${props => (props.isPropertyAltered ? AlteredPropertyColor : NormalPropertyColor)};
  font: normal normal bold 14px/24px Inter;
`

export const Name = styled.span``
export const Value = styled.span``

export const ReferenceValue = styled.div`
  flex-grow: 1;
  font: normal normal normal 14px/24px Inter;
  letter-spacing: 0;
  color: ${props => props.theme.colors.color6b7786};
`
